import React from "react";
import { Component, Fragment } from "react";
import {
	Card,
	CardBody,
	CardTitle,
	Row,
	Col,
	Button,

} from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import * as mqtt from 'react-paho-mqtt';
import Paho from 'paho-mqtt';
import { getConnectionURL } from "../../mqtt-helpers/mqtt-request";
import { authenticationService } from '../../jwt/_services';
import ReactGA from "react-ga4";

import {
	BatteryHealth,
	Booster200V,
	WifiStrength,
	VisualAudioStatus,
	BleStrength
} from '../../components/vitals/';

import {
	UsedPowerSettings,
	TotalProcedures,
	LaserUsage,
	TopProcedures,
	TopProceduresNova,
  TotalHourlyUsagePVM,
  TopProceduresCat,
	TopProceduresCatNova,
  WavelengthUsage
} from '../../components/mobile-vitals-dashboard/';

class MobileVitalsDashboard extends React.Component {

	constructor(props) {
    super(props);

		var connectionTimeout;

		// const currentUser = authenticationService.currentUserValue;
		// console.log('currentUser info: ' + JSON.stringify(currentUser));
		// console.log('currentUser info: ' + JSON.stringify(currentUser.token));

		this.onMessageArrived = this.onMessageArrived.bind(this);
    this.onConnectionLost = this.onConnectionLost.bind(this);

    this.state = {
			mainMessage: [''],
			noDevices: false,
			subMessage: [''],
			client: null,
      messageToSend:'',
			currentDevice: this.props.match.params.id,
      isConnected: false,
			isReceivingMessages: false,
			devices: [''],
			authToken: "",
			productID: 1,
			refreshKey: 0,
			isRefreshing: false,
			pullStartY: null,
			pullDistance: 0
	  };

  }

	componentDidMount() {

		ReactGA.pageview(window.location.pathname);

    const query = new URLSearchParams(this.props.location.search);
    const token = query.get('token')
    console.log("token: "+token)//123
		const productID = query.get('productID')
    console.log("productID: "+productID)//123

    if (token) {
      if (token.length>0) {
        console.log("authToken: "+token)
        this.setState({authToken:token});
      }
    }

		if (productID) {
      if (productID.length>0) {
        console.log("productID: "+productID)
        this.setState({productID});
      }
    }

    setTimeout(this.connectToMQTT, 1000);
		//this.connectToMQTT();

		if (this.state.currentDevice === "00000") {
			this.setState({noDevices: true});
		}

		//setInterval(this.checkIsConnected, 2000);
	}

	componentWillUnmount() {

		//var currentConnectedDevice = JSON.parse(localStorage.getItem('currentConnectedDevice'));

		// if (currentConnectedDevice == this.state.currentDevice) {
		// 	localStorage.setItem('currentConnectedDevice', '');
		// 	localStorage.setItem('isDeviceReceivingMessages', false);
		// }

		if (this.state.client && this.state.client.isConnected()) {
			this.state.client.disconnect();
		}

		clearTimeout(this.refreshTimeout);
		clearInterval(this.connectionTimeout);

	}

	isInteractiveTouchTarget = (target) => {
		if (!target || typeof target.closest !== "function") {
			return false;
		}

		return !!target.closest(
			"button, input, select, textarea, a, label, [role='button'], [role='option'], [role='listbox'], [contenteditable='true'], .dropdown, .dropdown-menu, .dropdown-item"
		);
	}

	handlePullStart = (event) => {
		if (
			window.scrollY > 0 ||
			this.state.isRefreshing ||
			event.touches.length !== 1 ||
			this.isInteractiveTouchTarget(event.target)
		) {
			return;
		}

		this.setState({ pullStartY: event.touches[0].clientY, pullDistance: 0 });
	}

	handlePullMove = (event) => {
		if (this.state.pullStartY === null || window.scrollY > 0 || this.state.isRefreshing) {
			return;
		}

		const pullDistance = Math.max(0, event.touches[0].clientY - this.state.pullStartY);

		if (pullDistance > 0) {
			this.setState({ pullDistance: Math.min(pullDistance, 90) });
		}
	}

	handlePullEnd = () => {
		if (this.state.pullStartY === null) {
			return;
		}

		if (this.state.pullDistance >= 70) {
			this.refreshDashboard();
			return;
		}

		this.setState({ pullStartY: null, pullDistance: 0 });
	}

	refreshDashboard = () => {
		this.setState((prevState) => ({
			refreshKey: prevState.refreshKey + 1,
			isRefreshing: true,
			pullStartY: null,
			pullDistance: 0
		}));

		if (this.state.client && this.state.client.isConnected()) {
			this.state.client.disconnect();
		}

		clearInterval(this.connectionTimeout);
		this.connectToMQTT();
		clearTimeout(this.refreshTimeout);
		this.refreshTimeout = setTimeout(() => {
			this.setState({ isRefreshing: false });
		}, 1200);
	}

  connectToMQTT = async () => {

    //var url = "https://hdlnjb45hb.execute-api.us-west-2.amazonaws.com/v1/request-url?RequestType=1";
    var url = "https://hdlnjb45hb.execute-api.us-west-2.amazonaws.com/v1/request-url?RequestType=0&SerialNumber="+this.state.currentDevice;

    var token = "";

		if (token = this.state.authToken) {
			token = token = this.state.authToken;
		}

    try {

      const response = await fetch(url, {
  			method: 'GET',
  			headers: {
  				Authorization: token
  			},
  		});

      const body = await response.json();
  		console.log("connectToMQTT body: " + JSON.stringify(body));

  		if (body.status == 'Success') {
        var hash = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        console.log('random hash: ' + hash);
        var clientIdHash = "g2_"+this.state.currentDevice+"_"+body.type;
        console.log('clientIdHash: ' + clientIdHash);
        this.state.client = new Paho.Client(body.response, clientIdHash);
        this.state.client.onMessageArrived = this.onMessageArrived;
        this.state.client.onConnectionLost = this.onConnectionLost;
        this.state.client.connect({
          timeout: 3,
          useSSL: true,
          mqttVersion: 4,
          cleanSession: true,
          onSuccess: this.onConnect,
          onFailure: (e) => {console.log("here is the error" , e); }
        });
  		} else {
        //ADD ERROR MESSAGE
        console.log('error response: ' + body.response);
      }

		}
		catch (err) {
			console.log("connectToMQTT error: "+err);
		}

	}

	// connectToMQTT = async () => {
	// 	authenticationService.getDeviceConnectionURL(this.state.currentDevice)
	// 			.then(
	// 					connectionUrl => {
	// 						console.log('connectToMQTT connectionUrl: ' + JSON.stringify(connectionUrl));
  //
	// 						//var url1 = "wss://a1f3ynjyzalf3r-ats.iot.us-west-2.amazonaws.com/mqtt?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAS3T2QUYOSMZKW4V2%2F20210201%2Fus-west-2%2Fiotdevicegateway%2Faws4_request&X-Amz-Date=20210201T225801Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=dff6d2d6b29772129d10a43adf2b218d07b3cd3423ac13e32c71c6d7f8032eaf";
  //
	// 						if (connectionUrl.status == 'Success') {
	// 							var hash = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
	// 							console.log('random hash: ' + hash);
	// 							var clientIdHash = "g2_"+this.state.currentDevice+"_"+connectionUrl.type;
	// 							this.state.client = new Paho.Client(connectionUrl.response, clientIdHash);
	// 							this.state.client.onMessageArrived = this.onMessageArrived;
	// 							this.state.client.onConnectionLost = this.onConnectionLost;
	// 							this.state.client.connect({
	// 								timeout: 3,
	// 								useSSL: true,
	// 								mqttVersion: 4,
	// 								cleanSession: true,
	// 								onSuccess: this.onConnect,
	// 								onFailure: (e) => {console.log("here is the error" , e); }
	// 							});
	// 						}
	// 					},
	// 					error => {
	// 						console.log('error.message: ' + error.message);
	// 					}
	// 			);
	// }

	checkIsConnected = () => {
		if (this.state.isReceivingMessages) {
			console.log("Vitals Is Connected!");
		} else {
			console.log("Vitals Is Not Connected!");
		}
	}

	updateIsConnected = () => {
		this.setState({isReceivingMessages: false});

		//localStorage.setItem('currentConnectedDevice', '');
		localStorage.setItem('isDeviceReceivingMessages', false);

		console.log("Vitals isReceivingMessages false");
	}

	onMessageArrived(entry) {
		this.setState({isReceivingMessages: true});
		clearTimeout(this.connectionTimeout)
    console.log("Vitals onMessageArrived:"+entry.payloadString);
		const msg = JSON.parse(entry.payloadString);

		localStorage.setItem('currentConnectedDevice', JSON.stringify(msg.serial_num));
		localStorage.setItem('isDeviceReceivingMessages', true);

		if (msg.batch) {
			this.setState({mainMessage: JSON.parse(entry.payloadString)});
			console.log("vitals_main_messages:"+this.state.mainMessage);
		} else {
			this.setState({subMessage: JSON.parse(entry.payloadString)});
			console.log("vitals_sub_messages:"+this.state.subMessage);
		}
		this.connectionTimeout = setInterval(this.updateIsConnected, 10000);
  }

  onConnect = () => {
    const { client } = this.state;
    console.log("Connected!!!!");
    //client.subscribe('00013/out');
    this.setState({isConnected: true, error: ''})
		//this.setState({isReceivingMessages: true})
		//this.sendMessage("@@@get_all");
		console.log('myCurrentDevice id: ' + this.state.currentDevice);
		//this.setState({currentDevice: this.state.currentDevice});
		const subChannel = this.state.currentDevice+'/out';
		this.state.client.subscribe(subChannel);
		this.connectionTimeout = setInterval(this.updateIsConnected, 10000);
  };


  sendMessage(){
    var message = new Paho.Message(this.state.messageToSend);
    message.destinationName = "00013";

    if(this.state.isConnected){
      this.state.client.send(message);
    }else{
      this.connect(this.state.client)
        .then(() => {
          this.state.client.send(message);
          this.setState({error: '', isConnected: true});
        })
        .catch((error)=> {
          console.log(error);
          this.setState({error: error});
        });
  	}
  }


  onConnectionLost(responseObject) {
    if (responseObject.errorCode !== 0) {
      console.log("vitals onConnectionLost:"+responseObject.errorMessage);
      this.setState({error: 'Lost Connection', isConnected: false});
    }
  }

	render() {
		const refreshIndicatorTop = this.state.isRefreshing ? 12 : Math.min(this.state.pullDistance - 42, 12);
		const refreshIndicatorOpacity = this.state.isRefreshing ? 1 : Math.min(this.state.pullDistance / 70, 1);
		const dashboardOffset = this.state.isRefreshing ? 52 : Math.min(this.state.pullDistance, 52);

		return (
			<div
				style={{ fontFamily: "Arial", background: "#000", minHeight: "100vh", overscrollBehaviorY: "contain" }}
				onTouchStart={this.handlePullStart}
				onTouchMove={this.handlePullMove}
				onTouchEnd={this.handlePullEnd}
				onTouchCancel={this.handlePullEnd}
			>
				<div
					style={{
						position: "fixed",
						top: refreshIndicatorTop,
						left: "50%",
						zIndex: 1000,
						width: 34,
						height: 34,
						marginLeft: -17,
						borderRadius: "50%",
						background: "#1c1c1c",
						border: "1px solid #444",
						color: "#e9c636",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						opacity: refreshIndicatorOpacity,
						transform: `rotate(${this.state.isRefreshing ? 360 : this.state.pullDistance * 3}deg)`,
						transition: this.state.pullStartY === null ? "top 180ms ease, opacity 180ms ease, transform 300ms ease" : "none",
						pointerEvents: "none"
					}}
				>
					<i className="mdi mdi-refresh" />
				</div>
				<div
					style={{
						transform: `translateY(${dashboardOffset}px)`,
						transition: this.state.pullStartY === null ? "transform 180ms ease" : "none"
					}}
				>
				{this.state.noDevices &&
						<Row className="mb-3">
							<Col md="2">
								<h1 style={{color:'#e04e28'}}>DASHBOARD</h1>
							</Col>
							<Col md="2">
								<h4 className="pt-3">No Devices</h4>
							</Col>
						</Row>
				}
				{!this.state.noDevices &&
				<Fragment>
				<Row className="mb-3">
					<Col xs="12" md="12" lg="12" xl="12" className="text-center" style={{ paddingLeft: 0, paddingRight: 0 }}>
						<h4 className="pt-3" style={{ width: "100%", textAlign: "center" }}>Serial {this.state.currentDevice}</h4>
						<p style={{ width: "100%", color: "#d6d6d6", fontSize: 13, margin: "0 auto", textAlign: "center" }}>
							Dashboard data can take up to 1 minute to fully load
						</p>
					</Col>
          {
            // <Col lg="6" xl="3">
  					// 	<h4 className="pt-3">Serial {this.state.currentDevice}</h4>
  					// </Col>
          }
				</Row>
				<Row style={{ padding: 10 }}>
          <Col lg="6" xl="4">
            <TotalHourlyUsagePVM key={`total-hourly-${this.state.refreshKey}`} loadDelay={0} currentDevice={this.state.currentDevice} authToken={this.state.authToken} product={this.state.productID} version={1} />
            <UsedPowerSettings key={`used-power-${this.state.refreshKey}`} loadDelay={500} currentDevice={this.state.currentDevice} authToken={this.state.authToken} product={this.state.productID} version={1} />
          </Col>
          <Col lg="6" xl="4">
            <TotalProcedures key={`total-procedures-${this.state.refreshKey}`} loadDelay={1000} currentDevice={this.state.currentDevice} authToken={this.state.authToken} product={this.state.productID} version={1} />
            <LaserUsage key={`laser-usage-${this.state.refreshKey}`} loadDelay={1500} currentDevice={this.state.currentDevice} authToken={this.state.authToken} product={this.state.productID} version={1} />
          </Col>
          <Col lg="6" xl="4">
            <WavelengthUsage key={`wavelength-usage-${this.state.refreshKey}`} loadDelay={2000} currentDevice={this.state.currentDevice} authToken={this.state.authToken} product={this.state.productID} version={1} />
          </Col>
					{this.state.productID === "1" &&
						<>
						<Col lg="6" xl="4">
	            <TopProcedures key={`top-procedures-${this.state.refreshKey}`} loadDelay={2500} currentDevice={this.state.currentDevice} authToken={this.state.authToken} product={this.state.productID} version={1} />
	          </Col>
	          <Col lg="6" xl="4">
	            <TopProceduresCat key={`top-procedures-cat-${this.state.refreshKey}`} loadDelay={3000} currentDevice={this.state.currentDevice} authToken={this.state.authToken} product={this.state.productID} version={1} />
	          </Col>
						</>
					}
					{this.state.productID === "2" &&
						<>
						<Col lg="6" xl="4">
	            <TopProceduresNova key={`top-procedures-nova-${this.state.refreshKey}`} loadDelay={2500} currentDevice={this.state.currentDevice} authToken={this.state.authToken} product={this.state.productID} version={1} />
	          </Col>
	          <Col lg="6" xl="4">
	            <TopProceduresCatNova key={`top-procedures-cat-nova-${this.state.refreshKey}`} loadDelay={3000} source="mobile-vitals-dashboard-rn" currentDevice={this.state.currentDevice} authToken={this.state.authToken} product={this.state.productID} version={1} />
	          </Col>
						</>
					}
					{
						// <Col lg="6" xl="4">
	          //   <Booster200V message={this.state.mainMessage} currentDevice={this.state.currentDevice} isReceivingMessages={this.state.isReceivingMessages} />
	          //   <BatteryHealth message={this.state.mainMessage} isReceivingMessages={this.state.isReceivingMessages} currentDevice={this.state.currentDevice}/>
						// </Col>
						// <Col lg="6" xl="4">
						// 	<WifiStrength message={this.state.mainMessage} isReceivingMessages={this.state.isReceivingMessages} currentDevice={this.state.currentDevice} />
						// 	<BleStrength message={this.state.mainMessage} isReceivingMessages={this.state.isReceivingMessages} currentDevice={this.state.currentDevice} />
						// </Col>
						// <Col lg="6" xl="4">
						// 	<VisualAudioStatus message={this.state.mainMessage} isReceivingMessages={this.state.isReceivingMessages} currentDevice={this.state.currentDevice}/>
						// </Col>
					}

				</Row>
				</Fragment>
				}
				</div>
			</div>
		);
	}
}

export default MobileVitalsDashboard;
